import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { FEE_PROVIDER_CATEGORY_TYPE } from '../actions';

const initialState = {};

const feeProviderCategoryReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case FEE_PROVIDER_CATEGORY_TYPE.GET_CATEGORIES:
        return payload || state;

      case FEE_PROVIDER_CATEGORY_TYPE.CREATE_CATEGORY:

      case FEE_PROVIDER_CATEGORY_TYPE.UPDATE_CATEGORY: {
        const id = payload.feeProviderCategoryId ?? payload.id;

        draft[id] = payload;
        break;
      }

      case FEE_PROVIDER_CATEGORY_TYPE.DELETE_CATEGORY:
        delete draft[meta.feeProviderCategoryId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default feeProviderCategoryReducer;
